import { useState } from 'react'
import { useSettings } from '../hooks/useSettings'

/**
 * 設定コンポーネント
 *
 * CoDMON資格情報の設定・削除を行う。
 */
export function Settings() {
  const { configured, codmonId, loading, saving, error, saveCredentials, deleteCredentials } = useSettings()
  const [inputId, setInputId] = useState('')
  const [inputPassword, setInputPassword] = useState('')
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setSuccessMessage(null)

    if (!inputId.trim() || !inputPassword.trim()) return

    const ok = await saveCredentials(inputId.trim(), inputPassword.trim())
    if (ok) {
      setInputId('')
      setInputPassword('')
      setSuccessMessage('CoDMON資格情報を保存しました')
    }
  }

  const handleDelete = async () => {
    setSuccessMessage(null)
    const ok = await deleteCredentials()
    if (ok) {
      setSuccessMessage('CoDMON資格情報を削除しました')
    }
  }

  if (loading) {
    return (
      <div className="settings">
        <h2>設定</h2>
        <div className="loading">読み込み中...</div>
      </div>
    )
  }

  return (
    <div className="settings">
      <h2>設定</h2>

      <div className="settings-section">
        <h3>CoDMON 資格情報</h3>
        <p className="settings-description">
          CoDMONのログインID（メールアドレス）とパスワードを設定すると、
          タイムライン・アルバム・連絡帳の同期機能が利用できます。
        </p>

        {error && <div className="settings-error">{error}</div>}
        {successMessage && <div className="settings-success">{successMessage}</div>}

        {configured && (
          <div className="settings-status">
            <div className="settings-status-badge configured">設定済み</div>
            <div className="settings-status-detail">
              <span className="settings-status-label">CoDMON ID:</span>
              <span className="settings-status-value">{codmonId}</span>
            </div>
          </div>
        )}

        <form className="settings-form" onSubmit={handleSave}>
          <div className="settings-field">
            <label htmlFor="codmon-id">CoDMON ID（メールアドレス）</label>
            <input
              id="codmon-id"
              type="email"
              className="settings-input"
              value={inputId}
              onChange={(e) => setInputId(e.target.value)}
              placeholder={configured ? '新しいIDで上書き' : 'example@email.com'}
              disabled={saving}
            />
          </div>

          <div className="settings-field">
            <label htmlFor="codmon-password">パスワード</label>
            <input
              id="codmon-password"
              type="password"
              className="settings-input"
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
              placeholder="パスワードを入力"
              disabled={saving}
            />
          </div>

          <div className="settings-actions">
            <button
              type="submit"
              className="button button-primary"
              disabled={saving || !inputId.trim() || !inputPassword.trim()}
            >
              {saving ? '保存中...' : configured ? '更新' : '保存'}
            </button>

            {configured && (
              <button
                type="button"
                className="button button-tertiary settings-delete-button"
                onClick={handleDelete}
                disabled={saving}
              >
                削除
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}
